"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../../Label"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _utils = _interopRequireDefault(require("../../utils/utils"));

var _fileUtils = _interopRequireDefault(require("../../utils/fileUtils"));

var _UploadItem = _interopRequireDefault(require("./UploadItem.style"));

var _dec, _class;

let UploadItem = (_dec = (0, _reactJss.default)(_UploadItem.default), _dec(_class = class UploadItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.removeFile = this.removeFile.bind(this);
  }

  removeFile() {
    const {
      onRemove,
      id
    } = this.props;
    onRemove(id);
  }

  renderPortalImg() {
    const {
      type,
      classes,
      label,
      value
    } = this.props;

    if (type.indexOf('image') === -1) {
      return _react.default.createElement(_Icon.default, {
        type: 'attach'
      });
    }

    return _react.default.createElement("img", {
      className: classes.chipImg,
      alt: label,
      src: value
    });
  }

  renderDefaultImg() {
    const {
      type,
      classes,
      label,
      value
    } = this.props;
    if (type.indexOf('image') === -1) return null;
    return _react.default.createElement("img", {
      className: classes.fileImg,
      alt: label,
      src: value
    });
  } // превью во внешнем потрале


  renderPortal() {
    const {
      classes,
      className,
      id,
      label,
      error,
      size,
      maxFileSizeErrorText,
      maxFileSize,
      closeIcon,
      onClick: _onClick
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      onClick: () => _onClick(id),
      className: (0, _clsx.default)(className, classes.fileItemChip, 'fileItemChip', {
        error
      })
    }, this.renderPortalImg(), _react.default.createElement("div", {
      className: classes.chipTextBox
    }, _react.default.createElement(_Label.default, {
      value: label,
      textColor: 'inherit',
      className: classes.chipText
    }), _react.default.createElement(_Label.default, {
      fontSize: 'small',
      value: error ? `${maxFileSizeErrorText} ${_fileUtils.default.biteToSize(maxFileSize)}` : `${_fileUtils.default.biteToSize(size)}`,
      visibility: error ? 'visible' : 'disabled',
      className: classes.chipHelperText
    })), closeIcon ? _react.default.createElement(_Icon.default, {
      type: "close",
      size: "small",
      color: 'currentColor',
      className: (0, _clsx.default)(classes.delFileIcon),
      onClick: this.removeFile
    }) : null);
  } // превью по умолчанию


  renderDefault() {
    const {
      classes,
      className,
      id,
      label,
      size,
      closeIcon,
      onClick: _onClick2
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.fileItem),
      onClick: () => _onClick2(id)
    }, _react.default.createElement("div", {
      className: classes.fileItemInfo
    }, _react.default.createElement(_Label.default, {
      value: label,
      fontWeight: "semibold"
    }), _react.default.createElement("br", null), _react.default.createElement(_Label.default, {
      value: `File size: ${_fileUtils.default.biteToSize(size)}`,
      fontSize: "small"
    }), _react.default.createElement("br", null), this.renderDefaultImg()), _react.default.createElement("div", {
      className: classes.fileItemControls
    }, closeIcon ? _react.default.createElement(_Icon.default, {
      className: classes.delFileBtn,
      type: "close",
      size: "small",
      onClick: this.removeFile
    }) : null));
  }

  render() {
    const {
      viewType
    } = this.props;
    return this[`render${_utils.default.toUpperLatter(viewType)}`]();
  }

}) || _class);
UploadItem.defaultProps = {
  closeIcon: true,
  visibility: 'visible',
  viewType: 'default',
  maxFileSize: null,
  onRemove: () => {},
  onClick: () => {},
  maxFileSizeErrorText: '',
  error: false
};
var _default = UploadItem;
exports.default = _default;